import {
    SelectedViewTypeSource,
    processCalendarViewType,
    updateSelectedViewType,
} from 'owa-calendar-module-store';

import { CalendarViewTypeEnumToDateRangeType } from 'owa-calendar-view-type';
import { DEFAULT_WORKWEEKDAYS } from './constants';
import { DatapointVariant } from 'owa-analytics-actions';
import type { SurfaceUserOptions } from 'owa-calendar-surface-core';
import { action } from 'satcheljs/lib/legacy';
import { createWorkWeekDaysArray } from 'owa-datetime-utils';
import { getNumDaysInDayRange } from 'owa-calendar-surface-options-utils';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { logUsage } from 'owa-analytics';
import { surfaceStore } from 'owa-calendar-surface-surface-store';
import { updateDateRangeType } from 'owa-calendar-surface';
import { isCurrentCultureRightToLeft } from 'owa-localize';

// TODO: VSO #88707 Separate module vs surface concerns in Calendar module

// Record UserOptions values once they become available to store.userOptions object
// TODO VSO 52990: Remove user config options being re-stored in the calendar store
export const initializeSurfaceOptions = action('initializeSurfaceOptions')(
    function initializeSurfaceOptions(): void {
        const userConfiguration = getUserConfiguration();
        const userOptions = userConfiguration.UserOptions;

        const userOptionsWorkDays = userOptions.WorkingHours.WorkDays;
        const workDays = createWorkWeekDaysArray(
            userOptionsWorkDays ? userOptionsWorkDays : DEFAULT_WORKWEEKDAYS
        );
        const storeWorkDays = surfaceStore.userOptions.workDays;

        surfaceStore.userOptions = getSurfaceOptions();
        surfaceStore.isInSplitView =
            userConfiguration.ViewStateConfiguration.CalendarViewInSplitMode;
        surfaceStore.timeZoneIds = [userOptions.TimeZone];

        const preferredCalendarViewType =
            userConfiguration.ViewStateConfiguration.CalendarViewTypeDesktop;

        const needForceUpdateRangeType: boolean =
            surfaceStore.userOptions.weekStartDay != userOptions.WeekStartDay ||
            workDays[0] != storeWorkDays[0] ||
            workDays[workDays.length - 1] != storeWorkDays[storeWorkDays.length - 1];

        const numDaysInDayRange = getNumDaysInDayRange();

        // Updating appropriate store values
        const viewType = processCalendarViewType(preferredCalendarViewType);
        updateSelectedViewType(viewType, SelectedViewTypeSource.InitializeSurfaceOptions);
        updateDateRangeType(
            CalendarViewTypeEnumToDateRangeType(viewType),
            surfaceStore,
            numDaysInDayRange,
            needForceUpdateRangeType,
            false // source not a user change
        );
        logUsage(
            'InitialCalendarSurfaceOptions',
            { numDays_1: numDaysInDayRange, isInSpitView_2: surfaceStore.isInSplitView },
            { variant: DatapointVariant.WarmOnly }
        );
    }
);

/**
 * Creates surface user options
 */
export function getSurfaceOptions(timeZoneOffset: number = 0): SurfaceUserOptions {
    let userConfiguration = getUserConfiguration();
    let userOptions = userConfiguration.UserOptions;

    return {
        isRTL: isCurrentCultureRightToLeft(),
        weekStartDay: userOptions.WeekStartDay,
        hourIncrement: userOptions.HourIncrement,
        showWeekNumbers: userOptions.ShowWeekNumbers,
        firstWeekOfYear: userOptions.FirstWeekOfYear as any,
        workHoursStartTimeInMinutes: userOptions.WorkingHours.WorkHoursStartTimeInMinutes,
        workHoursEndTimeInMinutes: userOptions.WorkingHours.WorkHoursEndTimeInMinutes,
        workDays: userOptions.WorkingHours.WorkDays
            ? createWorkWeekDaysArray(userOptions.WorkingHours.WorkDays)
            : createWorkWeekDaysArray(DEFAULT_WORKWEEKDAYS),
    };
}
